import firebase from "firebase/app";
import "firebase/functions";
import firestore from "src/apiService/firestore";
import { getUserId } from "src/config/storage";
import { USER_PLAN as UserPlan } from "src/enums/common.enum";
import type { Cookie } from "src/utils/extension";

export async function mercariIntegrationCreate(args: {
  cookies: Cookie[];
  integrationId?: string;
  username?: string;
  lastSync?: string;
  bankAccountId?: string;
  userAgent?: string;
}) {
  const f = firebase.functions().httpsCallable("mercari-integrationCreate");
  const { userAgent = navigator.userAgent, ...rest } = args;
  return await f({ ...rest, userAgent });
}

export async function mercariIntegrationDelete(id: string): Promise<void> {
  const f = firebase.functions().httpsCallable("mercari-deleteIntegration");
  await f({ integrationId: id });
}

export async function mercariIntegrationSyncChange(
  id: string,
  sync: boolean,
  inventory: boolean = true
) {
  const userId = await getUserId();
  const db = firestore();

  await db.runTransaction(async (transaction) => {
    const user = await transaction.get(db.collection("Users").doc(userId));
    await transaction.update(db.collection("Plaid_Integrations").doc(id), {
      sync: sync && user.data()?.plan === UserPlan.ULTIMATE,
      inventory: sync && inventory,
    });
  });
}

export async function getMercariIntegration() {
  const uid = await getUserId();
  const db = firestore();
  const integrations = await db
    .collection("Plaid_Integrations")
    .where("user", "==", uid)
    .where("type", "==", "mercari")
    .get();
  const integration = integrations.docs.pop();
  if (integration) {
    return integration.data();
  } else {
    return null;
  }
}
